import { render, staticRenderFns } from "./institution_index.vue?vue&type=template&id=11f6ce72&scoped=true"
import script from "./institution_index.vue?vue&type=script&lang=js"
export * from "./institution_index.vue?vue&type=script&lang=js"
import style0 from "./institution_index.vue?vue&type=style&index=0&id=11f6ce72&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f6ce72",
  null
  
)

export default component.exports